import React from 'react';
import './NoDataScreen.scss';
import { useTranslation } from "react-i18next";
import Button, { EButtonSize, EButtonType } from '../../../../Components/Buttons/Button';
import { useNavigate } from 'react-router-dom';
import { EPath } from '../../../../Core/EPath';
import draftingAnimation from '../../../../Assets/lottie/drafting.json';
import LottieAnimation from '../../../../Components/Animation/LottieAnimation';

export enum ENDSType {
    NO_TEMPLATE = 'no-template',
    NO_TEMPLATE_CONTENT = 'no-template-content',
    NO_DRAFT = 'no-draft',
    NO_CLAUSE = 'no-clause',
    NO_SMARTFIELDS = 'no-smartfields'
}

interface INDSProps {
    type: ENDSType;
    onClick?: () => void;
}

const NoDataScreen = (props: INDSProps) => {

    const { type, onClick } = props;
    const { t } = useTranslation();

    const getNoDataMessage = () => {
        switch(type) {
            case ENDSType.NO_TEMPLATE:
                return t('drafting.noTemplate');
            case ENDSType.NO_DRAFT:
                return t('drafting.noDraft');
            case ENDSType.NO_TEMPLATE_CONTENT:
                return t('drafting.noTemplateContent');
            case ENDSType.NO_CLAUSE:
                return t('drafting.noClause');
            case ENDSType.NO_SMARTFIELDS:
                return t('drafting.noSmartfields');
        }
    }

    const getNoDataButtonText = () => {
        switch(type) {
            case ENDSType.NO_TEMPLATE:
                return "+ " + t('drafting.newTemplate');
            case ENDSType.NO_DRAFT:
                return "+ " + t('drafting.new');
            case ENDSType.NO_TEMPLATE_CONTENT:
                return "← " + t('drafting.backToTemplates');
            case ENDSType.NO_CLAUSE:
                return "+ " + t('drafting.newClause');
            case ENDSType.NO_SMARTFIELDS:
                return t('drafting.newSmartfield');
        }
    }

    const navigate = useNavigate();

    const click = () => {

        if(onClick) return onClick();

        switch(type) {
            case ENDSType.NO_TEMPLATE:
                navigate(EPath.TEMPLATE_CREATE);
                break;
            case ENDSType.NO_DRAFT:
                navigate(EPath.DRAFT_CREATE);
                break;
            case ENDSType.NO_TEMPLATE_CONTENT:
                navigate(EPath.TEMPLATE);
                break;
        }
    }

    const showAnimation = type !== ENDSType.NO_SMARTFIELDS;

    return (
        <div className="nds-container">
            <h3>{getNoDataMessage()}</h3>
            <Button 
                text={getNoDataButtonText()}
                buttonType={EButtonType.PRIMARY}
                size={EButtonSize.NORMAL}
                onClick={click}
            />
            {showAnimation && <LottieAnimation 
                animationData={draftingAnimation}
            />}
        </div>
    );
};

export default NoDataScreen;